import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { formatPrice } from 'utils/formatters';

import { CommissionItem, CommissionStatus } from './hooks/useCommissions';

const STATUS_COLORS: Record<CommissionStatus, string> = {
  pending: 'bg-yellow-100 text-yellow-900',
  confirmed: 'bg-blue-100 text-blue-900',
  updated: 'bg-blue-100 text-blue-900',
  finalized: 'bg-green-100 text-green-900',
  refunded: 'bg-gray-200 text-gray-900',
  expired: 'bg-gray-200 text-gray-700',
};

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

const formatMoney = (m: { amountSubunits: number; currencyCode: string }) =>
  formatPrice(m.amountSubunits / 100, m.currencyCode);

export const columns: ColumnDef<CommissionItem>[] = [
  {
    accessorKey: 'createdAt',
    header: 'Date',
    cell: ({ getValue }) => formatDate(getValue<string>()),
  },
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) => <span className="font-mono text-sm">{getValue<string>()}</span>,
  },
  {
    accessorKey: 'checkoutIntentId',
    header: 'Checkout Intent',
    cell: ({ getValue }) => {
      const id = getValue<string>();
      return (
        <Link
          to={`/checkout-intents/${id}`}
          className="font-mono text-sm underline"
          onClick={(e) => e.stopPropagation()}
        >
          {id}
        </Link>
      );
    },
  },
  {
    accessorKey: 'developerCommission',
    header: 'Earnings',
    cell: ({ row }) => (
      <span className="text-green-600">{formatMoney(row.original.developerCommission)}</span>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => {
      const status = getValue<CommissionStatus>();
      return (
        <span
          className={`inline-block rounded-md px-2 py-0.5 text-xs capitalize ${
            STATUS_COLORS[status] ?? 'bg-gray-100'
          }`}
        >
          {status}
        </span>
      );
    },
  },
];
